import React, { Component } from 'react'

import { Overlay, DialogOuter, Dialog, Wrapper, Header, Body, Close, IconWrapper } from './Dialog.styles'
import { Icon } from '../../shared/tr-icons'

export default class Prompt extends Component {
  constructor(props) {
    super(props)

    this.state = {
      active: props.active || false
    }
  }

  render() {
    let headerClasses = ['']

    if (this.props.headerClass) {
      headerClasses = headerClasses.concat(['prompt__content-header'])
    }

    if (this.state.active) {
      return (
        <div className='ui__prompt'>
          <Overlay>
            <DialogOuter>
              <Dialog>
                <Close
                  href='/'
                  className='prompt__close svg__cross'
                  onClick={this._handleCloseClick}
                  data-testid='dialog-close'
                >
                  <Icon type='close' />
                </Close>

                <Wrapper>
                  <Header className={headerClasses.join(' ')}>
                    <IconWrapper className='ui__icon icon__svg' />
                  </Header>

                  <Body>{this.props.children}</Body>
                </Wrapper>
              </Dialog>
            </DialogOuter>
          </Overlay>
        </div>
      )
    }
    return null
  }

  _handleCloseClick = evt => {
    evt.preventDefault()

    const { onClose } = this.props

    this.setState({
      active: false
    })

    if (onClose && typeof onClose === 'function') {
      onClose()
    }
  }
}

Prompt.propTypes = {}
